<va-status-banner
  type="info"
  statusText="{{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.COMPLETE_SETUP' | translate }}"
></va-status-banner>

<mat-stepper
  #stepper
  data-testid="meeting-scheduler-setup-wizard"
  class="schedule-stepper"
  labelPosition="bottom"
  [selectedIndex]="(wizardStep$ | async) || 0"
  (selectionChange)="onStepperSelectionChange($event)"
>
  <mat-step [label]="(stepLabels$ | async)?.step1 || 'Step 1'" [completed]="((wizardStep$ | async) || 0) >= 1">
    <meeting-scheduler-calendar-slug-card
      [calendarId]="personalCalendarId$ | async"
      [setInitial]="true"
      [showHeaderIcon]="true"
      buttonLabel="{{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUTTONS.NEXT' | translate }}"
      (saveButtonClicked)="setStep(stepper.selectedIndex + 1)"
    ></meeting-scheduler-calendar-slug-card>
  </mat-step>

  <mat-step [label]="(stepLabels$ | async)?.step2 || 'Step 2'" [completed]="((wizardStep$ | async) || 0) >= 2">
    <meeting-scheduler-settings-calendar-card
      *ngIf="(featureMicrosoftTeamsEnabled$ | async) === true"
      (calendarProviderSelected)="handleCalendarProvider($event)"
    >
      <mat-card-actions align="end" class="action-bar">
        <meeting-scheduler-connect-with-google-button
          *ngIf="selectedCalendarProvider === 'google'"
          [serviceKey]="SERVICE_KEYS.settingsPageCalendarConnected"
          [primaryDisconnect]="false"
        ></meeting-scheduler-connect-with-google-button>
        <meeting-scheduler-connect-with-microsoft-button
          *ngIf="selectedCalendarProvider === 'microsoft'"
          [serviceKey]="SERVICE_KEYS.settingsPageCalendarConnected"
          [primaryDisconnect]="false"
        ></meeting-scheduler-connect-with-microsoft-button>

        <button
          *ngIf="
            (isGoogleMeetConfigured && selectedCalendarProvider === 'google') ||
            (isMicrosoftConfigured && selectedCalendarProvider === 'microsoft')
          "
          [disabled]="disableStep2Next$ | async"
          mat-raised-button
          color="primary"
          type="submit"
          matStepperNext
          class="step-3-next-button"
        >
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUTTONS.NEXT' | translate }}
        </button>
      </mat-card-actions>
    </meeting-scheduler-settings-calendar-card>
    <meeting-scheduler-settings-calendar-card
      *ngIf="(featureMicrosoftTeamsEnabled$ | async) === false"
      (calendarProviderSelected)="handleCalendarProvider($event)"
    >
      <mat-card-actions align="end" class="action-bar">
        <meeting-scheduler-connect-with-google-button
          [serviceKey]="SERVICE_KEYS.settingsPageCalendarConnected"
          [primaryDisconnect]="false"
        ></meeting-scheduler-connect-with-google-button>
        <button
          *ngIf="isGoogleMeetConfigured"
          [disabled]="disableStep2Next$ | async"
          mat-raised-button
          color="primary"
          type="submit"
          matStepperNext
          class="step-3-next-button"
        >
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUTTONS.NEXT' | translate }}
        </button>
      </mat-card-actions>
    </meeting-scheduler-settings-calendar-card>
  </mat-step>

  <mat-step [label]="(stepLabels$ | async)?.step3 || 'Step 3'" [completed]="((wizardStep$ | async) || 0) >= 3">
    <meeting-scheduler-settings-meeting-app-card
      [serviceKey]="SERVICE_KEYS.settingsPageConferencingConnected"
      [hostPreferences]="hostPreferences"
      (integrationSelection)="onIntegrationSelection($event)"
    >
      <mat-card-actions class="step-2-actions">
        <button
          *ngIf="integrationsPageLink$ | async as integrationsPageLink"
          mat-stroked-button
          [routerLink]="[integrationsPageLink]"
        >
          Open integration settings
        </button>
        <button
          [disabled]="!selectedIntegrationConnected"
          mat-raised-button
          color="primary"
          type="submit"
          matStepperNext
          class="step-3-next-button"
        >
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUTTONS.NEXT' | translate }}
        </button>
      </mat-card-actions>
    </meeting-scheduler-settings-meeting-app-card>
  </mat-step>

  <mat-step [label]="(stepLabels$ | async)?.step4 || 'Step 4'" [completed]="((wizardStep$ | async) || 0) === 4">
    <meeting-scheduler-settings-availability-card
      [isHostConfigured]="isHostConfigured"
      (availabilitySaved)="onAvailabilitySaved()"
    ></meeting-scheduler-settings-availability-card>
  </mat-step>
</mat-stepper>
<!--  -->
